import React, { useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const history = useHistory();
  const [canRender, setCanRender] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("profile"));

    // No user → go to login
    if (!user) {
      history.replace("/login");
      return;
    }

    // FIXED: correct path to expiry date
    const expiryDate = user?.reminder?.expiryDate;

    if (expiryDate) {
      const now = new Date();
      const exp = new Date(expiryDate);

      // If expired → logout + redirect
      if (now > exp) {
        localStorage.removeItem("profile");
        history.replace("/login");
        return;
      }
    }

    setCanRender(true);
  }, [history]);

  return (
    <Route
      {...rest}
      render={(props) => (canRender ? <Component {...props} /> : null)}
    />
  );
};

export default ProtectedRoute;
